import styled from "@emotion/styled";

export const StyledOpenSign = styled.div``;
